"use strict";
/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpaceRole = exports.ParticipantEventType = exports.GetSpaceParticipantsParamsSort = void 0;
/** Field to sort by */
var GetSpaceParticipantsParamsSort;
(function (GetSpaceParticipantsParamsSort) {
    GetSpaceParticipantsParamsSort["LAST_NAME"] = "lastName";
    GetSpaceParticipantsParamsSort["ROLE"] = "role";
})(GetSpaceParticipantsParamsSort = exports.GetSpaceParticipantsParamsSort || (exports.GetSpaceParticipantsParamsSort = {}));
/** Type of event */
var ParticipantEventType;
(function (ParticipantEventType) {
    ParticipantEventType["ADD_PARTICIPANT"] = "addParticipant";
    ParticipantEventType["UPDATE_PARTICIPANT"] = "updateParticipant";
    ParticipantEventType["DELETE_PARTICIPANT"] = "deleteParticipant";
})(ParticipantEventType = exports.ParticipantEventType || (exports.ParticipantEventType = {}));
/** Space role given to the participant */
var SpaceRole;
(function (SpaceRole) {
    SpaceRole["EDUCATOR"] = "educator";
    SpaceRole["STUDENT"] = "student";
})(SpaceRole = exports.SpaceRole || (exports.SpaceRole = {}));
